import { useState } from "react";
import { ListItem } from "../__shared__/ListItem/ListItem";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";

import { PartnershipCardPointsSideDrawer } from "./components/SideDrawer/PartnershipCardPointsSideDrawer";

type Props = {
  /**
   * An optional string representing the CSS class name.
   */
  className?: string;
  /**
   * A number representing the points.
   */
  points: number;
};

export const PartnershipCardPointsUI = ({ className = "", points }: Props) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  const handleButtonClick = () => {
    setDrawerOpen(true);
  };

  return (
    <div className={className} data-testid="cardpoints:container">
      <ListItem
        trailingIcon={<ArrowRight />}
        onClick={handleButtonClick}
        label={`Earn ${points} points when you pay for this product with your Partnership Credit Card. 27.9% APR Representative (variable).`}
        description={"Credit subject to status. 18 years +. T&Cs apply."}
      />
      <PartnershipCardPointsSideDrawer
        handleClose={() => setDrawerOpen(false)}
        drawerIsOpen={drawerOpen}
        points={points}
      />
    </div>
  );
};
